import { debug, observer, pr, React, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { history } from "stores/RouterStore";
import { ISigningResponse } from "types/signing";
import { numberToCurrencyString } from "util/helpers";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { CardTanSettingsStore } from "./CardTanSettingsStore";
import { CardTanSettingsRoutes } from "./CardTanSettingsRoutes";

type IProps = {
    store: CardTanSettingsStore;
};

@observer
export class CardTanSettingsPinSigning extends React.Component<IProps, {}> {
    render() {
        const signInfo = this.props.store.changePinResponse?.signInfo;

        return (
            <SigningComponent
                useWebVersion
                signingInfo={signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("cardTanSettings.pin.signing.action")}</pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onError={async (response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    this.props.store.resetPinValues();
                    pushRoute(CardTanSettingsRoutes.CHANGE_PIN_ERROR);
                }}

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    this.props.store.resetPinValues();
                    pushRoute(CardTanSettingsRoutes.CHANGE_PIN_SUCCESS);
                }}

                onClose={async () => {
                    history.goBack();
                }}

                onRetry={async () => {
                    await this.props.store.changePin();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/cardTanSettings/CardTanSettingsPinSigning.tsx